import type { DatePickerProps } from 'react-datepicker';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import './style.scss';

const DatePicker = ({ ...props }: DatePickerProps) => {
  return (
    <ReactDatePicker showPopperArrow={false} showYearDropdown dropdownMode="select" {...props} />
  );
};

export { DatePicker };
